export const normalizeDate = (input: string) => {
  const trimmed = input.trim();

  // Already valid ISO: YYYY-MM-DD
  if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) return trimmed;

  // Extract ISO from embedded garbage like "52024-10-01"
  const isoMatch = trimmed.match(/(\d{4}-\d{2}-\d{2})/);
  if (isoMatch) return isoMatch[1];

  const altMatch = trimmed.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{4})$/);
  if (altMatch) {
    const [, m, d, y] = altMatch;
    if (m && d && y) {
      // runtime safety check
      const normalized = `${y}-${m.padStart(2, '0')}-${d.padStart(2, '0')}`;
      const date = new Date(normalized);
      if (!isNaN(date.getTime())) return normalized;
    }
  }

  return undefined;
};
